export default __webpack_public_path__ + "004a38d16e683fcda935df676225dc91.svg";